// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.AvatarCell_scroll__luYM7::-webkit-scrollbar {
  height: 8px;
}
.AvatarCell_scroll__luYM7::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.AvatarCell_scroll__luYM7::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.AvatarCell_AvatarCell__f7LRy {
  display: flex;
  align-items: center;
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_textHolderWithImg__LL3ny {
  width: calc(100% - 35px);
  line-height: 1.2;
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_textHolder__9r9My {
  width: 100%;
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_smallCell__YZOYW p {
  max-width: 60px;
  white-space: nowrap;
  line-height: 12px;
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_Translate__l0iaw {
  display: flex;
  gap: 5px;
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_nameStyle__6CySY {
  font-size: 12px;
  max-width: 85%;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  font-family: chirp;
}
body[dir=rtl] .AvatarCell_AvatarCell__f7LRy .AvatarCell_nameStyle__6CySY {
  text-align: right;
}
body[dir=ltr] .AvatarCell_AvatarCell__f7LRy .AvatarCell_nameStyle__6CySY {
  text-align: left;
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_nameStyle__6CySY[data-multiline=true] {
  white-space: pre-line;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 10px;
}
.AvatarCell_AvatarCell__f7LRy div:first-child {
  -webkit-margin-end: 3px;
          margin-inline-end: 3px;
}
@media (max-width: 992px) {
  .AvatarCell_AvatarCell__f7LRy div:first-child {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_markedImportant__OtGk1 {
  -webkit-margin-start: 5px;
          margin-inline-start: 5px;
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_markedImportant__OtGk1 svg {
  width: 15px;
  height: 14px;
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_markedImportant__OtGk1 svg path {
  fill: var(--secondaryColor);
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_icon__PZP5W {
  -webkit-margin-before: 0.2em;
          margin-block-start: 0.2em;
  -webkit-margin-end: 0.5em;
          margin-inline-end: 0.5em;
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_imgContainer__x5Lh0 {
  width: 30px;
  height: 30px;
  -webkit-margin-end: 0.5em;
          margin-inline-end: 0.5em;
  flex-shrink: 0;
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_imgContainer__x5Lh0 img,
.AvatarCell_AvatarCell__f7LRy .AvatarCell_imgContainer__x5Lh0 svg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_imgContainer__x5Lh0.AvatarCell_smallCell__YZOYW {
  width: 18px;
  height: 18px;
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_borderStyle__8jsF6 {
  border: 2px solid var(--secondaryColor);
}
.AvatarCell_AvatarCell__f7LRy .AvatarCell_rounded__Fqxxi {
  overflow: hidden;
  border-radius: 50%;
}

.AvatarCell_tableFont__MXyXp {
  font-size: 10px !important;
}

.AvatarCell_minWidth__SSa5o {
  max-width: 75% !important;
}

.AvatarCell_descStyle__9oe21 {
  font-size: 10px !important;
  text-transform: lowercase;
}

.AvatarCell_avatarImg__1jMH8 {
  width: 35px;
  height: 35px;
  -webkit-margin-end: 13px;
          margin-inline-end: 13px;
}
.AvatarCell_avatarImg__1jMH8 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.AvatarCell_AvatarCell__f7LRy .thumbnail {
  width: 34px !important;
  height: auto;
}

.AvatarCell_time__5BeBv {
  display: flex;
  align-items: center;
}
.AvatarCell_time__5BeBv span {
  font-size: 8px;
}
.AvatarCell_time__5BeBv span:first-child {
  -webkit-margin-end: 25px;
          margin-inline-end: 25px;
}

.AvatarCell_smallImg__bwc04 .thumbnail {
  width: 16px !important;
  height: 16px !important;
  margin: 8px 0;
  -webkit-margin-end: 5px;
          margin-inline-end: 5px;
}

.AvatarCell_clickable__di5nb {
  cursor: pointer;
}
.AvatarCell_clickable__di5nb:hover {
  color: var(--secondaryColor);
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/Tables/Cells/AvatarCell/AvatarCell.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,aAAA;EACA,mBAAA;AAsDF;AArDE;EACE,wBAAA;EACA,gBAAA;AAuDJ;AArDE;EACE,WAAA;AAuDJ;AArDE;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;AAuDJ;AArDE;EACE,aAAA;EACA,QAAA;AAuDJ;AArDE;EACE,eAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AAuDJ;AAtDI;EACE,iBAAA;AAwDN;AArDI;EACE,gBAAA;AAuDN;AArDI;EACE,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AAuDN;AApDE;EAEE,uBAAA;UAAA,sBAAA;AAqDJ;ADwDE;EC/GA;IAII,oBAAA;IACA,qBAAA;IACA,4BAAA;EAuDJ;AACF;AArDE;EACE,yBAAA;UAAA,wBAAA;AAuDJ;AAtDI;EACE,WAAA;EACA,YAAA;AAwDN;AAvDM;EACE,2BAAA;AAyDR;AArDE;EACE,4BAAA;UAAA,yBAAA;EACA,yBAAA;UAAA,wBAAA;AAuDJ;AArDE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;UAAA,wBAAA;EACA,cAAA;AAuDJ;AAtDI;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AAwDN;AAtDI;EACE,WAAA;EACA,YAAA;AAwDN;AArDE;EACE,uCAAA;AAuDJ;AArDE;EACE,gBAAA;EACA,kBAAA;AAuDJ;;AApDA;EDeI,0BAAA;ACyCJ;;AArDA;EACE,yBAAA;AAwDF;;AAtDA;EDSI,0BAAA;ECPF,yBAAA;AAyDF;;AAvDA;EACE,WAAA;EACA,YAAA;EACA,wBAAA;UAAA,uBAAA;AA0DF;AAzDE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA2DJ;;AArDI;EACE,sBAAA;EACA,YAAA;AAwDN;;AAnDA;EACE,aAAA;EACA,mBAAA;AAsDF;AArDE;EACE,cAAA;AAuDJ;AAtDI;EACE,wBAAA;UAAA,uBAAA;AAwDN;;AAlDI;EACE,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;UAAA,sBAAA;AAqDN;;AAjDA;EACE,eAAA;AAoDF;AAnDE;EACE,4BAAA;AAqDJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.AvatarCell {\n  display: flex;\n  align-items: center;\n  .textHolderWithImg {\n    width: calc(100% - 35px);\n    line-height: 1.2;\n  }\n  .textHolder {\n    width: 100%;\n  }\n  .smallCell p {\n    max-width: 60px;\n    white-space: nowrap;\n    line-height: 12px;\n  }\n  .Translate {\n    display: flex;\n    gap: 5px;\n  }\n  .nameStyle {\n    font-size: 12px;\n    max-width: 85%;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    display: inline-block;\n    font-family: chirp;\n    #{$rtl} & {\n      text-align: right;\n    }\n\n    #{$ltr} & {\n      text-align: left;\n    }\n    &[data-multiline='true'] {\n      white-space: pre-line;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      font-size: 10px;\n    }\n  }\n  div:first-child {\n    // margin-block: 10px;\n    margin-inline-end: 3px;\n    @include Sm {\n      display: -webkit-box;\n      -webkit-line-clamp: 1;\n      -webkit-box-orient: vertical;\n    }\n  }\n  .markedImportant {\n    margin-inline-start: 5px;\n    svg {\n      width: 15px;\n      height: 14px;\n      path {\n        fill: var(--secondaryColor);\n      }\n    }\n  }\n  .icon {\n    margin-block-start: 0.2em;\n    margin-inline-end: 0.5em;\n  }\n  .imgContainer {\n    width: 30px;\n    height: 30px;\n    margin-inline-end: 0.5em;\n    flex-shrink: 0;\n    img,\n    svg {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n    &.smallCell {\n      width: 18px;\n      height: 18px;\n    }\n  }\n  .borderStyle {\n    border: 2px solid var(--secondaryColor);\n  }\n  .rounded {\n    overflow: hidden;\n    border-radius: 50%;\n  }\n}\n.tableFont {\n  @include fontSize(10);\n}\n.minWidth {\n  max-width: 75% !important;\n}\n.descStyle {\n  @include fontSize(10);\n  text-transform: lowercase;\n}\n.avatarImg {\n  width: 35px;\n  height: 35px;\n  margin-inline-end: 13px;\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.AvatarCell {\n  :global {\n    .thumbnail {\n      width: 34px !important;\n      height: auto;\n    }\n  }\n}\n\n.time {\n  display: flex;\n  align-items: center;\n  span {\n    font-size: 8px;\n    &:first-child {\n      margin-inline-end: 25px;\n    }\n  }\n}\n.smallImg {\n  :global {\n    .thumbnail {\n      width: 16px !important;\n      height: 16px !important;\n      margin: 8px 0;\n      margin-inline-end: 5px;\n    }\n  }\n}\n.clickable {\n  cursor: pointer;\n  &:hover {\n    color: var(--secondaryColor);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `AvatarCell_scroll__luYM7`,
	"AvatarCell": `AvatarCell_AvatarCell__f7LRy`,
	"textHolderWithImg": `AvatarCell_textHolderWithImg__LL3ny`,
	"textHolder": `AvatarCell_textHolder__9r9My`,
	"smallCell": `AvatarCell_smallCell__YZOYW`,
	"Translate": `AvatarCell_Translate__l0iaw`,
	"nameStyle": `AvatarCell_nameStyle__6CySY`,
	"markedImportant": `AvatarCell_markedImportant__OtGk1`,
	"icon": `AvatarCell_icon__PZP5W`,
	"imgContainer": `AvatarCell_imgContainer__x5Lh0`,
	"borderStyle": `AvatarCell_borderStyle__8jsF6`,
	"rounded": `AvatarCell_rounded__Fqxxi`,
	"tableFont": `AvatarCell_tableFont__MXyXp`,
	"minWidth": `AvatarCell_minWidth__SSa5o`,
	"descStyle": `AvatarCell_descStyle__9oe21`,
	"avatarImg": `AvatarCell_avatarImg__1jMH8`,
	"time": `AvatarCell_time__5BeBv`,
	"smallImg": `AvatarCell_smallImg__bwc04`,
	"clickable": `AvatarCell_clickable__di5nb`
};
export default ___CSS_LOADER_EXPORT___;
